var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKwd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2536 16.4399C23.736 15.1399 24 13.7338 24 12.266C24 10.7981 23.736 9.39205 23.2536 8.09207L12 7.04858L0.746391 8.09207C0.264047 9.39205 0 10.7981 0 12.266C0 13.7338 0.264047 15.1399 0.746391 16.4399L12 17.4833L23.2536 16.4399Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 24.2653C17.1593 24.2653 21.5578 21.0088 23.2533 16.4392H0.746094C2.44166 21.0088 6.84013 24.2653 11.9998 24.2653Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 0.267334C6.84012 0.267334 2.44166 3.52383 0.746094 8.09344H23.2534C21.5578 3.52383 17.1593 0.267334 11.9997 0.267334Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 3.78296C-1.17157 8.46924 -1.17157 16.0673 3.51471 20.7536C4.73791 19.5304 5.93182 18.3365 7.82609 16.4422V8.09438L3.51471 3.78296Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKwd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/KWD.e5df715a442b68279a9480a6637df4d0.svg";